<template>
  <div class="d-flex align-center flex-column pt-3">
    <div class="_temp_list">
      <v-card flat class="pa-4">
        <div class="d-flex px-2 align-start mb-2">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                small
                @click="$router.go(-1)"
                icon
              >
                <v-icon color="#006341">mdi-reply</v-icon></v-btn
              >
            </template>
            <span>Back</span>
          </v-tooltip>
          <h3 class="mx-2">Managing Data Alumni</h3>
        </div>
      </v-card>
      <div class="my-5 d-flex align-center justify-space-between">
        <div>
          <v-btn
            v-if="storage_id.length"
            depressed
            color="#016443"
            @click="assignToRegion"
            dark
            class="text-capitalize mr-2"
          >
            <v-icon class="mr-2">mdi-login</v-icon>
            Assign to region
          </v-btn>
        </div>
        <div class="d-flex">
          <v-btn
            depressed
            color="#016443"
            to="/admin/msn/alumni/manage-university"
            dark
            class="text-capitalize mr-2"
            v-if="permissions.includes('ELSN') || role == 'SUPERADMIN'"
          >
            <v-icon class="mr-2">mdi-office-building-cog</v-icon>
            manage universities
          </v-btn>
          <v-btn
            depressed
            color="#016443"
            @click="createUser"
            dark
            class="text-capitalize mr-2"
            v-if="permissions.includes('ELSN') || role == 'SUPERADMIN'"
          >
            <v-icon class="mr-2">mdi-plus-box</v-icon>
            Add
          </v-btn>
          <v-btn
            v-if="permissions.includes('ELSN') || role == 'SUPERADMIN'"
            depressed
            color="#016443"
            to="/admin/msn/alumni/import-data"
            dark
            class="text-capitalize mr-2"
          >
            <v-icon>mdi-file-upload</v-icon>
            Import Data
          </v-btn>
          <v-btn
            color="#016443"
            depressed
            dark
            @click="exportData"
            class="text-capitalize"
          >
            <v-icon>mdi-file-download</v-icon>
            Export Data
          </v-btn>
        </div>
      </div>
      <div class="mt-4">
        <v-row align="center">
          <v-col cols="12" md="4">
            <p class="default_txt">Search name, email or username alumni</p>
            <v-text-field
              placeholder="Search"
              solo
              v-model="find"
              @keyup="fetchData"
              hide-details
              dense
              prepend-inner-icon="mdi-magnify"
              flat
              color="#006341"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="2">
            <p class="default_txt">Select Year TF</p>
            <v-select
              dense
              hide-details
              :items="getYear"
              item-text="state"
              item-value="abbr"
              v-model="year"
              @change="fetchData()"
              placeholder="Filter Year"
              flat
              solo
            ></v-select>
          </v-col>
          <v-col cols="12" md="2">
            <p class="default_txt">Select Year PTN</p>
            <v-select
              dense
              hide-details
              :items="getYear"
              item-text="state"
              item-value="abbr"
              v-model="ptn"
              @change="fetchData()"
              placeholder="Filter Year PTN"
              flat
              solo
            ></v-select>
          </v-col>

          <v-col cols="12" md="4" v-if="listTsa">
            <p class="default_txt">Select University</p>
            <v-select
              dense
              hide-details
              :items="listTsa"
              item-text="name"
              item-value="id"
              v-model="tsa"
              @change="fetchData()"
              placeholder="Filter University"
              flat
              solo
            ></v-select>
          </v-col>
        </v-row>
      </div>
      <div class="mt-3">
        <v-skeleton-loader
          class="my-5"
          type="table-tbody"
          v-if="loading"
        ></v-skeleton-loader>
        <div v-if="dataSet && !loading && dataSet">
          <v-data-table
            :headers="headers"
            :items="dataSet"
            :page.sync="page"
            :items-per-page="limit"
            class="elevation-0 color_txt"
            hide-default-footer
            :single-select="false"
            :item-class="row_classes"
            :show-select="permissions.includes('ELSN')"
            v-model="storage_id"
          >
            <template v-slot:[`item.no`]="{ item }">
              {{
                dataSet
                  .map((x) => {
                    return x.id;
                  })
                  .indexOf(item.id) +
                1 +
                (page - 1) * limit
              }}
            </template>
            <template v-slot:[`item.status`]="{ item }">
              <div class="d-flex">
                <v-icon
                  v-if="item.status == 1"
                  :disabled="!permissions.includes('ELSN')"
                  @click="switchStatus(item)"
                  large
                  color="blue"
                  style="cursor: pointer"
                  >mdi-toggle-switch</v-icon
                >
                <v-icon
                  :disabled="!permissions.includes('ELSN')"
                  v-if="item.status == 0"
                  @click="switchStatus(item)"
                  large
                  style="cursor: pointer"
                  >mdi-toggle-switch-off-outline</v-icon
                >
              </div>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <div class="d-flex">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      small
                      depressed
                      fab
                      class="text-capitalize"
                      v-bind="attrs"
                      v-on="on"
                      :to="`/admin/msn/alumni/${item.user_id}/manage-profile-alumni`"
                    >
                      <v-icon dark small> mdi-cog </v-icon>
                    </v-btn>
                  </template>
                  <span>Manage User</span>
                </v-tooltip>
              </div>
            </template>
          </v-data-table>
        </div>
        <div class="my-2">
          <v-menu v-model="menuLimit" bottom :nudge-bottom="55" elevation="0">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                depressed
                class="text-capitalize color_txt"
                height="38px"
                color="#fff"
                v-bind="attrs"
                v-on="on"
                ><p class="default_txt">Show : {{ limit }}</p>
                <v-icon>mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <v-card class="popup_radius" outlined elevation="0">
              <v-list>
                <v-list-item link @click="changeLimit(10)">
                  <v-list-item-title>10</v-list-item-title>
                </v-list-item>
                <v-list-item link @click="changeLimit(50)">
                  <v-list-item-title>50</v-list-item-title>
                </v-list-item>
                <v-list-item link @click="changeLimit(100)">
                  <v-list-item-title>100</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-card>
          </v-menu>
        </div>
        <div class="text-center my-2 pa-3" v-if="dataSet">
          <v-pagination
            v-model="page"
            color="#006341"
            @input="fetchData"
            :length="last_page"
          ></v-pagination>
        </div>
        <div
          class="empty d-flex align-center justify-center flex-column"
          v-if="!dataSet && !loading"
        >
          <img
            src="../../../assets/img/redaksi/pagenotfound.png"
            height="250px"
            alt=""
          />
          <b class="default_txt my-3">Data not found</b>
        </div>
      </div>
    </div>
    <div class="pa-2">
      <dialog-large
        :d_large="d_large"
        @refetch="storage_id = []"
        @close="d_large = false"
        :inventory="inventory"
        :type="d_type"
        :title="d_title"
        line="true"
      />
      <dialog-medium
        :d_create="d_create"
        @refetch="fetchData"
        @close="d_create = false"
        :inventory="inventory"
        :type="d_type"
        :title="d_title"
      />
      <dialog-small
        :d_small="d_small"
        @refetch="fetchData"
        @close="d_small = false"
        :inventory="inventory"
        :type="d_type"
        :title="d_title"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import dialogSmall from "../../dialog/dialogSmall.vue";
export default {
  components: { dialogSmall },
  name: "manageDataAlumni",
  computed: {
    ...mapState({
      permissions: (state) => state.permissions,
      role: (state) => state.role,
    }),
    getYear() {
      let data = [];
      let year = parseInt(this.$date().format("YYYY"));
      for (let i = 2000; i <= year; i++) {
        data.push({
          state: i,
          abbr: i,
        });
      }
      data.push({
        state: "All Year",
        abbr: "",
      });
      return data;
    },
  },
  data() {
    return {
      loading: false,
      d_create: false,
      d_large: false,
      d_small: false,
      hide_title: "",
      btnTitle: "",
      inventory: "",
      d_type: "",
      d_title: "",
      dataSet: null,
      page: 1,
      limit: 10,
      find: "",
      tsa: "",
      listTsa: null,
      year: "",
      ptn: "",
      headers: [
        {
          text: "NO",
          align: "start",
          sortable: false,
          value: "no",
        },
        {
          text: "ID",
          align: "start",
          sortable: false,
          value: "no_tf",
        },
        {
          text: "FULL NAME",
          align: "start",
          sortable: false,
          value: "name",
        },
        {
          text: "EMAIL",
          align: "start",
          sortable: false,
          value: "email",
        },
        {
          text: "YEAR TF",
          align: "start",
          sortable: false,
          value: "year_tf",
        },
        {
          text: "REGION",
          align: "start",
          sortable: false,
          value: "region.region.region",
        },
        { text: "TYPE", sortable: false, value: "type" },
        { text: "STATUS", sortable: false, value: "status" },
        { text: "ACTION", sortable: false, value: "actions" },
      ],
      menuLimit: false,
      storage_id: [],
    };
  },
  mounted() {
    this.fetchData();
    this.getTsa();
  },
  methods: {
    fetchData() {
      this.loading = true;
      let data = {
        path: `manage/graduate?page[number]=${this.page}&page[size]=${this.limit}&filter[university_id]=${this.tsa}&filter[year_tf]=${this.year}&filter[year_ptn]=${this.ptn}&filter[search]=${this.find}&include=region`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.loading = false;
          this.dataSet = data.data;
          this.total = data.total;
          this.last_page = data.last_page;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    getTsa() {
      let data = {
        path: `manage/graduate/university`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.listTsa = data.data;
          let reset = {
            id: "",
            name: "All University",
          };
          this.listTsa.unshift(reset);
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    exportData() {
      let data = {
        path: `support/graduation/export?filter[title]=${this.find}`,
        body: "",
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          location.href = data.path;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
        });
    },
    switchStatus(item) {
      this.d_type = "switch";
      item["module"] = "scholar";
      this.d_title = "";
      this.inventory = item;
      this.d_small = true;
    },
    createUser() {
      this.d_type = "c_scholar";
      this.d_title = "Add Alumni";
      this.d_create = true;
      this.inventory = {
        path: "manage/graduate",
      };
    },

    changeLimit(val) {
      this.limit = val;
      this.fetchData();
    },
    // s_region
    assignToRegion() {
      let id = this.storage_id.map((el) => {
        return el.id;
      });
      this.inventory = id;
      this.d_type = "s_region";
      this.d_title = "Select Region";
      this.d_large = true;
    },
    row_classes(item) {
      let idx = this.dataSet.indexOf(item);
      if (idx % 2 == 0) {
        return "strip_"; //can also return multiple classes e.g ["orange","disabled"]
      }
    },
  },
};
</script>

<style></style>
